import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;
  grid-gap: 4px;
  grid-template-rows: auto auto;
`;
